import { api } from "../../App";
import { createNotification } from "../../components/Notifications/Notifications";
import {
    GET_HEALTH_GROUP
} from "../types";

export const getHealthgroup = () => async (dispatch, getState) => {
    try {
        const { data } = await api.get(`/healthgroup`);
        dispatch({ type: GET_HEALTH_GROUP, payload: data });
    } catch (error) {
    }
};

export const updateHealthgroup = (params) => async (dispatch, getState) => {
    try {
        await api.put(`/healthgroup/${params.hid}`, params);
        await dispatch(getHealthgroup());
    } catch (error) {
    }
};

export const createHealthgroup = (data) => async (dispatch, getState) => {
    try {
        await api.post(`/healthgroup`, data);
        createNotification('success', 'Успешно');
        await dispatch(getHealthgroup());
    } catch (error) {
        createNotification('error', "Не удалось создать запись");
    }
};

export const deleteHealthgroup = (groupsId) => async (dispatch, getState) => {
    try {
        await api.delete(`/healthgroup/${groupsId}`);
        await dispatch(getHealthgroup());
        createNotification('success', 'Успешно');
    } catch (error) {
        createNotification('error', "Не удалось удалить запись");
    }
};